import { useUserProfileQuery } from "@graphql/api";
import ConcentricLoader from "@hudson/ui/components/Loader/ConcentricLoader";
import Form from "./Form";

function dropTypename(object) {
  if (object?.__typename) {
    delete object.__typename;
  }
  return object;
}

export default function Profile() {
  const { data: profileData, loading: profileLoading, error } = useUserProfileQuery();

  if (error) {
    console.error(error);
    return null;
  }

  return profileLoading ? (
    <ConcentricLoader className="max-w-2xl px-4 mx-auto opacity-60 sm:py-10 sm:px-6 lg:px-8" />
  ) : (
    <Form profile={dropTypename({ ...profileData?.userProfile?.contactInfo })} />
  );
}
